import React from 'react'
import './index.scss'

export default function Line() {
  return (
    <div className='connectsu-line-vertical'></div>
  )
}
